import { MasterDataListPage } from "@/features/master-data/pages/MasterDataList";

const MasterDataList = () => {
  return <MasterDataListPage />;
};

export default MasterDataList;
